import React, { useState, useRef } from 'react';
import './calculatorWindow.css';

export default function CalculatorWindow({ title, onClose, initialPosition, allowClose = true, children }) {
  const [pos, setPos] = useState(initialPosition || { x: 40, y: 80 });
  const [minimized, setMinimized] = useState(false);
  const drag = useRef(null);
  const winRef = useRef(null);

  const startDrag = (clientX, clientY) => { drag.current = { dx: clientX - pos.x, dy: clientY - pos.y }; };
  const moveDrag = (clientX, clientY) => {
    if (!drag.current) return;
    const w = winRef.current?.offsetWidth || 240;
    const maxX = Math.max(0, window.innerWidth - w);
    const maxY = Math.max(0, window.innerHeight - 44);
    setPos({
      x: Math.min(Math.max(0, clientX - drag.current.dx), maxX),
      y: Math.min(Math.max(0, clientY - drag.current.dy), maxY),
    });
  };
  const endDrag = () => { drag.current = null; };

  const onMouseDown = (e) => {
    e.preventDefault();
    startDrag(e.clientX, e.clientY);
    const mm = (ev) => moveDrag(ev.clientX, ev.clientY);
    const mu = () => { endDrag(); window.removeEventListener('mousemove', mm); window.removeEventListener('mouseup', mu); };
    window.addEventListener('mousemove', mm); window.addEventListener('mouseup', mu);
  };
  const onTouchStart = (e) => { const t = e.touches[0]; startDrag(t.clientX, t.clientY); };
  const onTouchMove = (e) => { const t = e.touches[0]; moveDrag(t.clientX, t.clientY); };

  if (minimized) {
    return (
      <button className="calcWindowTab" style={{ left: pos.x, top: pos.y }}
        onClick={() => setMinimized(false)} aria-label="Rechner öffnen">
        🧮 {title}
      </button>
    );
  }

  return (
    <div className="calcWindow" style={{ left: pos.x, top: pos.y }} ref={winRef}>
      <div className="calcWindowHeader"
        onMouseDown={onMouseDown} onTouchStart={onTouchStart} onTouchMove={onTouchMove}
        onTouchEnd={endDrag} onTouchCancel={endDrag}>
        <span className="calcWindowTitle">{title}</span>
        <span className="calcWindowBtns">
          <button aria-label="minimieren" onClick={() => setMinimized(true)}>–</button>
          {allowClose && <button aria-label="schließen" onClick={onClose}>✕</button>}
        </span>
      </div>
      <div className="calcWindowBody">{children}</div>
    </div>
  );
}
